import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SubscriptionsComponent } from './subscriptions.component';
import { ComponentsModule } from '../../../components/components.module';
import { ButtonModule } from 'primeng/button';
import { TreeTableModule } from 'primeng/treetable';
import { CheckboxModule } from 'primeng/checkbox';
import { FormsModule } from '@angular/forms';
import { ToastModule } from 'primeng/toast';
import { InputTextModule } from 'primeng/inputtext';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { MenuModule } from 'primeng/menu';
import { PipesModule } from '../../../pipes/pipes.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [SubscriptionsComponent],
  imports: [
    CommonModule,
    ComponentsModule,
    ButtonModule,
    TreeTableModule,
    CheckboxModule,
    FormsModule,
    ToastModule,
    InputTextModule,
    ButtonModule,
    ConfirmDialogModule,
    DialogModule,
    MenuModule,
    PipesModule,
    TranslateModule
  ],
  exports: [SubscriptionsComponent]
})
export class SubscriptionsModule { }
